import AddIcon from "@mui/icons-material/Add";
import CropFreeIcon from "@mui/icons-material/CropFree";
import SearchIcon from "@mui/icons-material/Search";
import {
    Autocomplete,
    Button,
    Collapse,
    IconButton,
    Menu,
    MenuItem,
} from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import moment from "moment";
import "moment/locale/id";
import { MetodeBayarData, ProsesParkirResponse } from "../../constants/types";

import { Typography } from "@mui/material";

import { InputAdornment } from "@mui/material";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

import { LoadingButton } from "@mui/lab";
import { red } from "@mui/material/colors";
import { pdf } from "@react-pdf/renderer";
import defaultAxios, { AxiosError } from "axios";
import { IconContext } from "react-icons";
import { GiMoneyStack, GiWallet } from "react-icons/gi";
import { useMutation } from "react-query";
import Swal from "sweetalert2";
import SETOSQRIS from "../../assets/images/SETOSQRIS.jpg";
import CardSubs from "../../components/CardSubs/CardSubs";
import LicensePlateInput from "../../components/LicensePlateInput/LicensePlateInput";
import ModalImportMember from "../../components/ModalImportMember/ModalImportMember";
import ModalMember from "../../components/ModalMember/ModalMember";
import ModalPilihKantong from "../../components/ModalPilihKantong/ModalPilihKantong";
import PrintStrukMember from "../../components/PrintStrukMember/PrintStrukMember";
import { useAuth } from "../../context/authContext";
import axios from "../../services/axios";
import useKantungParkir from "../../services/queries/useKantungParkir";
import useMetodePembayaran from "../../services/queries/useMetodePembayaran";
import useShiftNow from "../../services/queries/useShiftNow";
import useUkm from "../../services/queries/useUkm";
import useUser from "../../services/queries/useUser";
import { getLocalUkmId } from "../../utils/handleChangeUkmId";
import toRibuan from "../../utils/toRibuan";

moment.locales();
moment.locale("id");

type Body = {
    noPolisi: string;
};

enum ModePembayaran {
    TUNAI = "tunai",
    TRANSFER = "transfer",
}

interface VehicleType {
    id: number;
    nama: string;
    harga: number;
}

interface PembayaranResponse {
    code: number;
    message: string;
    data: {
        nomorInvoice: string;
    };
}

function hexToRgb(hex: string | undefined): string {
    if (!hex) return "255, 255, 255";

    hex = hex.replace(/^#/, "");

    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }

    const num = parseInt(hex, 16);
    const r = (num >> 16) & 255;
    const g = (num >> 8) & 255;
    const b = num & 255;

    return `${r}, ${g}, ${b}`;
}

const Sewa = () => {
    let nowMember = moment().format("DD MMM YYYY");
    // let nowShift = moment().format("YYYY-MM-DD");

    // Helper function to check if subscription is truly active
    const isSubscriptionActive = (data: ProsesParkirResponse["data"]) => {
        if (!data) return false;

        const today = moment().startOf("day");
        const endDate = data.endLangganan
            ? moment(data.endLangganan).startOf("day")
            : null;

        // Subscription is inactive if: isActive === 0 OR endLangganan has passed
        if (data.isActive === 0) return false;
        if (endDate && endDate.isBefore(today)) return false;

        // Subscription is active if: isActive === 1 AND endLangganan hasn't passed
        return (
            data.isActive === 1 &&
            (endDate ? endDate.isSameOrAfter(today) : false)
        );
    };

    const { ukmIdUser } = useAuth();
    const { data: user } = useUser();
    const initialParamsUkm = {
        size: 500,
        page: 1,
        search: "",
    };
    const { data: ukm } = useUkm(initialParamsUkm);
    const ukmId = useMemo(() => {
        if (user?.userId) {
            return getLocalUkmId(user?.userId);
        }
        return null;
    }, [user?.userId]);

    const ukmData = useMemo(() => {
        if (ukmId) {
            return ukm?.content.find((li) => li.id === ukmId);
        }
        return ukm?.content[0];
    }, [ukm?.content, ukmId]);

    const [idMember, setIdMember] = useState<string>("");
    const [selectedNoPol, setSelectedNoPol] = useState<string>("");
    const [prosesParkirRes, setProsesParkirRes] =
        useState<ProsesParkirResponse | null>(null);
    const [toggleModePembayaran, setToggleModePembayaran] = useState(
        ModePembayaran.TUNAI,
    );

    const [isProcessingPayment, setIsProcessingPayment] = useState(false);

    const { data: metodePembayaran, isLoading: isLoadingMetodePembayaran } =
        useMetodePembayaran(ukmId);

    useEffect(() => {
        if (metodePembayaran) {
            const metode = metodePembayaran.find(
                (li) => li.isBayarParkir === 1,
            );
            if (!metode) return;
            setSelectedMetode(metode);
        }
    }, [metodePembayaran]);

    const [selectedMetode, setSelectedMetode] =
        useState<MetodeBayarData | null>(null);

    const [isOpenModalMember, setIsOpenModalMember] = useState(false);

    const openModalMember = () => setIsOpenModalMember(true);
    const closeModalMember = () => setIsOpenModalMember(false);

    const [isOpenImport, setIsOpenImport] = useState(false);

    const openModalImport = () => setIsOpenImport(true);
    const closeModalImport = () => setIsOpenImport(false);

    const [isMemberLoaded, setIsMemberLoaded] = useState(false);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const pilihTunai = () => {
        setToggleModePembayaran(ModePembayaran.TUNAI);
    };

    const pilihQRIS = () => {
        setToggleModePembayaran(ModePembayaran.TRANSFER);
    };

    const prosesParkir = useMutation({
        mutationFn: async (values: Body) => {
            const res = await axios.post<ProsesParkirResponse>(
                "/api/parkirs",
                values,
            );
            return res.data;
        },
    });

    const handlePrintStruk = async (invoiceNumber: string) => {
        if (!ukmData) return;

        try {
            const blob = await pdf(
                <PrintStrukMember
                    namaToko={String(ukmData?.namaToko)}
                    alamatToko={String(ukmData?.alamatToko)}
                    gambarToko={
                        ukmData?.gambarTokoBW === null
                            ? undefined
                            : ukmData?.gambarTokoBW
                    }
                    telpToko={String(ukmData?.noTelp)}
                    tanggalTransaksi={nowMember}
                    noInvoice={invoiceNumber}
                    isPro={Number(ukmData?.isPro)}
                    nominalLangganan={
                        selectedVehicleType?.harga?.toString() ??
                        ukmData?.biayaParkir?.toString() ??
                        "5000"
                    }
                    noPolisi={selectedNoPol}
                    namaMetode={
                        toggleModePembayaran === ModePembayaran.TUNAI
                            ? "Tunai"
                            : selectedMetode?.namaMetode
                    }
                />,
            ).toBlob();

            const pdfUrl = URL.createObjectURL(blob);
            window.open(pdfUrl);
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    };

    const inputPembayaran = async () => {
        const body = {
            ukmId: ukmIdUser && ukmIdUser[0],
            noPolisi: selectedNoPol,
            metodeId:
                toggleModePembayaran === ModePembayaran.TUNAI
                    ? 0
                    : selectedMetode?.id,
            totalPembayaran:
                selectedVehicleType?.harga?.toString() ??
                ukmData?.biayaParkir ??
                5000,
            tipeKendaraan: selectedVehicleType?.id,
            charge: selectedMetode?.charge?.charge ?? null,
            tipeCharge: selectedMetode?.charge?.mode ?? null,
        };

        try {
            setIsProcessingPayment(true);
            const { data } = await axios.post<PembayaranResponse>(
                "/api/parkirs/transaksi",
                body,
            );

            if (data.code === 200) {
                Swal.fire({
                    title: "Pembayaran berhasil!",
                    text: `Nomor Invoice: ${data.data.nomorInvoice}`,
                    position: "top-end",
                    showConfirmButton: false,
                    icon: "success",
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    showCloseButton: true,
                    customClass: {
                        container: "my-swal",
                    },
                });

                // Cetak struk dengan nomor invoice
                await handlePrintStruk(data.data.nomorInvoice);

                // Reset state
                setTimeout(() => {
                    setProsesParkirRes(null);
                    setIdMember("");
                    setSelectedNoPol("");
                    setIsMemberLoaded(false);
                    setIsProcessingPayment(false);
                }, 1000);
            }
        } catch (error) {
            console.log(error);
            setIsProcessingPayment(false);
            handleErrorResponse(error);
        }
    };

    const handleErrorResponse = useCallback((error) => {
        if (defaultAxios.isAxiosError(error)) {
            const serverError = error as AxiosError<any>;
            if (serverError && serverError.response) {
                Swal.fire({
                    title: "Terjadi Kesalahan!",
                    text: `${serverError.response.data.data}`,
                    icon: "error",
                    confirmButtonColor: "#45A779",
                    customClass: {
                        container: "my-swal",
                    },
                });
            } else {
                Swal.fire({
                    title: "Terjadi Kesalahan!",
                    text: `Telah Terjadi Kesalahan`,
                    icon: "error",
                    confirmButtonColor: "#45A779",
                    customClass: {
                        container: "my-swal",
                    },
                });
            }
        }
    }, []);

    const [selectedVehicleType, setSelectedVehicleType] =
        useState<VehicleType | null>(null);

    const { data: kantungParkir } = useKantungParkir({
        page: 1,
        size: 100,
    });

    const { data: shiftNow } = useShiftNow({
        ukmId: ukmIdUser && ukmIdUser[0],
        tipe: "now",
    });

    const [isOpenModalPilihKantong, setIsOpenModalPilihKantong] =
        useState(false);

    const openModalPilihKantong = () => {
        setIsOpenModalPilihKantong(true);
    };

    const closeModalPilihKantong = () => {
        setIsOpenModalPilihKantong(false);
    };

    useEffect(() => {
        if (shiftNow?.mulaiShift === null) {
            openModalPilihKantong();
        }
    }, [shiftNow?.mulaiShift]);

    useEffect(() => {
        if (kantungParkir && kantungParkir.content.length > 0) {
            const vehicle = kantungParkir?.content?.find(
                (kantung) => kantung.id === shiftNow?.kantungParkir?.id,
            )?.tipeKendaraan;

            if (!vehicle || vehicle.length === 0) return;
            setSelectedVehicleType(vehicle[0]);
        }
    }, [kantungParkir, metodePembayaran, shiftNow?.kantungParkir?.id]);

    return (
        <Box>
            <Grid container minHeight="100dvh" spacing={2}>
                <Grid item xs={12}>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        flexWrap="wrap"
                        gap={2}
                        mt={2}
                    >
                        <Box alignItems="center">
                            <Typography fontSize={32} fontWeight={700}>
                                Scan Barcode
                            </Typography>
                        </Box>
                        <Box visibility="hidden">
                            <Button
                                variant="outlined"
                                onClick={handleClick}
                                startIcon={<AddIcon />}
                                size="medium"
                                sx={{
                                    padding: "15px 20px",
                                }}
                            >
                                Tambah Member
                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                // sx={{ mt: 6 }}
                            >
                                <MenuItem
                                    onClick={() => {
                                        openModalMember();
                                        handleClose();
                                    }}
                                >
                                    Tambah Member Satuan
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        openModalImport();
                                        handleClose();
                                    }}
                                >
                                    Tambah Member Excel
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Stack>

                    {shiftNow?.kantungParkir.nama && (
                        <Typography fontWeight={600} mt={2}>
                            Kantung Parkir : {shiftNow?.kantungParkir.nama}
                        </Typography>
                    )}

                    <Box alignItems="center" mt={4}>
                        <Stack
                            direction={{ xs: "row" }}
                            justifyContent="space-between"
                            alignItems="center"
                            spacing={2}
                        >
                            <Box width="80%">
                                <LicensePlateInput
                                    autoFocus
                                    // disabled={prosesParkir.isLoading}
                                    placeholder="ID Member"
                                    size="medium"
                                    fullWidth
                                    value={idMember}
                                    onChange={(event) => {
                                        setIdMember(event);
                                    }}
                                    onKeyPress={(e) => {
                                        const element =
                                            e.target as HTMLInputElement;
                                        if (e.key === "Enter") {
                                            if (!isMemberLoaded) {
                                                prosesParkir.mutate(
                                                    { noPolisi: element.value },
                                                    {
                                                        onSuccess: (res) => {
                                                            setSelectedNoPol(
                                                                element.value,
                                                            );
                                                            setProsesParkirRes(
                                                                res,
                                                            );
                                                            setIsMemberLoaded(
                                                                true,
                                                            );
                                                        },
                                                        onError: (err) => {
                                                            console.log(err);
                                                            setProsesParkirRes(
                                                                null,
                                                            );
                                                            setIsMemberLoaded(
                                                                false,
                                                            );
                                                            Swal.fire({
                                                                title: "Terjadi Kesalahan!",
                                                                text: `Data member tidak ditemukan`,
                                                                icon: "error",
                                                                confirmButtonColor:
                                                                    "#45A779",
                                                                customClass: {
                                                                    container:
                                                                        "my-swal",
                                                                },
                                                            });
                                                        },
                                                    },
                                                );
                                            } else {
                                                if (
                                                    prosesParkirRes &&
                                                    !prosesParkirRes.data &&
                                                    ukmData?.biayaParkir
                                                ) {
                                                    inputPembayaran();
                                                }
                                            }
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    <SearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                />
                            </Box>

                            <Box width="20%">
                                <LoadingButton
                                    loading={prosesParkir.isLoading}
                                    loadingPosition="start"
                                    variant="contained"
                                    onClick={() =>
                                        prosesParkir.mutate(
                                            { noPolisi: idMember },
                                            {
                                                onSuccess: (res) => {
                                                    setSelectedNoPol(idMember);
                                                    setProsesParkirRes(res);
                                                    setIsMemberLoaded(true);
                                                },
                                                onError: (err) => {
                                                    console.log(err);
                                                    setProsesParkirRes(null);
                                                    setIsMemberLoaded(false);
                                                    Swal.fire({
                                                        title: "Terjadi Kesalahan!",
                                                        text: `Data member tidak ditemukan`,
                                                        icon: "error",
                                                        confirmButtonColor:
                                                            "#45A779",
                                                        customClass: {
                                                            container:
                                                                "my-swal",
                                                        },
                                                    });
                                                },
                                            },
                                        )
                                    }
                                    startIcon={<CropFreeIcon />}
                                    size="large"
                                    fullWidth
                                    sx={{
                                        padding: "10px",
                                        fontSize: "20px",
                                    }}
                                >
                                    Scan
                                </LoadingButton>
                            </Box>
                        </Stack>
                        <Collapse in={Boolean(prosesParkirRes)}>
                            {prosesParkirRes ? (
                                <Stack spacing={2} mt={2}>
                                    <Stack
                                        // alignItems="center"
                                        justifyContent="center"
                                        padding="20px"
                                        sx={{
                                            backgroundColor: prosesParkirRes
                                                .data?.isActive
                                                ? `rgba(${hexToRgb(
                                                      isSubscriptionActive(
                                                          prosesParkirRes.data,
                                                      )
                                                          ? "#119C5B"
                                                          : red[400],
                                                  )}, 0.1)`
                                                : "#fff",
                                            border: prosesParkirRes.data
                                                ?.isActive
                                                ? `1px solid ${
                                                      isSubscriptionActive(
                                                          prosesParkirRes.data,
                                                      )
                                                          ? "#119C5B"
                                                          : red[400]
                                                  }`
                                                : "1px solid rgba(0, 0, 0, 0.2)",
                                            borderRadius: "10px",
                                        }}
                                    >
                                        {prosesParkirRes.data ? (
                                            <Typography
                                                color={
                                                    isSubscriptionActive(
                                                        prosesParkirRes.data,
                                                    )
                                                        ? "#119C5B"
                                                        : red[400]
                                                }
                                                textAlign="center"
                                            >
                                                {isSubscriptionActive(
                                                    prosesParkirRes.data,
                                                )
                                                    ? "Langganan Aktif"
                                                    : "Langganan Non-Aktif"}
                                            </Typography>
                                        ) : null}
                                        {!prosesParkirRes.data &&
                                        ukmData?.biayaParkir ? (
                                            <>
                                                <Autocomplete
                                                    options={
                                                        kantungParkir?.content?.find(
                                                            (kantung) =>
                                                                kantung.id ===
                                                                shiftNow
                                                                    ?.kantungParkir
                                                                    ?.id,
                                                        )?.tipeKendaraan || []
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Jenis Kendaraan"
                                                            variant="outlined"
                                                        />
                                                    )}
                                                    getOptionLabel={(option) =>
                                                        option.nama
                                                    }
                                                    isOptionEqualToValue={(
                                                        option,
                                                        value,
                                                    ) =>
                                                        String(option.id) ===
                                                        String(value.id)
                                                    }
                                                    fullWidth
                                                    value={selectedVehicleType}
                                                    onChange={(
                                                        _event,
                                                        newVehicleType: {
                                                            id: number;
                                                            nama: string;
                                                            harga: number;
                                                        } | null,
                                                    ) => {
                                                        setSelectedVehicleType(
                                                            newVehicleType,
                                                        );
                                                    }}
                                                />
                                                <Stack
                                                    mt={2}
                                                    direction="row"
                                                    justifyContent="space-around"
                                                    flexWrap="wrap"
                                                    gap={2}
                                                    alignItems="center"
                                                >
                                                    <Stack>
                                                        <Typography
                                                            variant="h3"
                                                            fontWeight={500}
                                                            textAlign="center"
                                                        >
                                                            Bayar Langsung
                                                        </Typography>
                                                        {selectedNoPol ? (
                                                            <Typography
                                                                variant="h2"
                                                                fontWeight={700}
                                                                textAlign="center"
                                                            >
                                                                {selectedNoPol}
                                                            </Typography>
                                                        ) : null}
                                                    </Stack>
                                                    <Typography
                                                        variant="h1"
                                                        fontWeight={700}
                                                        textAlign="center"
                                                    >
                                                        {/* {toRibuan(
                                                        ukmData?.biayaParkir,
                                                    )} */}

                                                        {toRibuan(
                                                            selectedVehicleType?.harga ||
                                                                0,
                                                        )}
                                                    </Typography>
                                                </Stack>
                                            </>
                                        ) : null}
                                    </Stack>
                                    {prosesParkirRes.data &&
                                    !isSubscriptionActive(
                                        prosesParkirRes.data,
                                    ) ? (
                                        <Stack
                                            // alignItems="center"
                                            justifyContent="center"
                                            padding="20px"
                                            sx={{
                                                backgroundColor: `rgba(${hexToRgb(
                                                    "#fff",
                                                )}, 0.1)`,
                                                border: `1px solid ${"rgba(0, 0, 0, 0.2)"}`,
                                                borderRadius: "10px",
                                            }}
                                        >
                                            {ukmData?.biayaParkir ? (
                                                <>
                                                    <Autocomplete
                                                        options={
                                                            kantungParkir?.content?.find(
                                                                (kantung) =>
                                                                    kantung.id ===
                                                                    shiftNow
                                                                        ?.kantungParkir
                                                                        ?.id,
                                                            )?.tipeKendaraan ||
                                                            []
                                                        }
                                                        renderInput={(
                                                            params,
                                                        ) => (
                                                            <TextField
                                                                {...params}
                                                                label="Jenis Kendaraan"
                                                                variant="outlined"
                                                            />
                                                        )}
                                                        getOptionLabel={(
                                                            option,
                                                        ) => option.nama}
                                                        isOptionEqualToValue={(
                                                            option,
                                                            value,
                                                        ) =>
                                                            String(
                                                                option.id,
                                                            ) ===
                                                            String(value.id)
                                                        }
                                                        fullWidth
                                                        value={
                                                            selectedVehicleType
                                                        }
                                                        onChange={(
                                                            _event,
                                                            newVehicleType: {
                                                                id: number;
                                                                nama: string;
                                                                harga: number;
                                                            } | null,
                                                        ) => {
                                                            setSelectedVehicleType(
                                                                newVehicleType,
                                                            );
                                                        }}
                                                    />
                                                    <Stack
                                                        mt={2}
                                                        direction="row"
                                                        justifyContent="space-around"
                                                        flexWrap="wrap"
                                                        gap={2}
                                                        alignItems="center"
                                                    >
                                                        <Stack>
                                                            <Typography
                                                                variant="h3"
                                                                fontWeight={500}
                                                                textAlign="center"
                                                            >
                                                                Bayar Langsung
                                                            </Typography>
                                                            {selectedNoPol ? (
                                                                <Typography
                                                                    variant="h2"
                                                                    fontWeight={
                                                                        700
                                                                    }
                                                                    textAlign="center"
                                                                >
                                                                    {
                                                                        selectedNoPol
                                                                    }
                                                                </Typography>
                                                            ) : null}
                                                        </Stack>
                                                        <Typography
                                                            variant="h1"
                                                            fontWeight={700}
                                                            textAlign="center"
                                                        >
                                                            {/* {toRibuan(
                                                        ukmData?.biayaParkir,
                                                    )} */}

                                                            {toRibuan(
                                                                selectedVehicleType?.harga ||
                                                                    0,
                                                            )}
                                                        </Typography>
                                                    </Stack>
                                                </>
                                            ) : null}
                                        </Stack>
                                    ) : null}
                                    {prosesParkirRes.data ? (
                                        <CardSubs data={prosesParkirRes.data} />
                                    ) : null}
                                    {isSubscriptionActive(
                                        prosesParkirRes.data,
                                    ) ? null : (
                                        <Box>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={6}>
                                                    <Button
                                                        fullWidth
                                                        variant={
                                                            toggleModePembayaran ===
                                                            ModePembayaran.TUNAI
                                                                ? "contained"
                                                                : "outlined"
                                                        }
                                                        onClick={pilihTunai}
                                                        sx={{
                                                            borderRadius: 4,
                                                            py: 2,
                                                        }}
                                                    >
                                                        <Stack alignItems="center">
                                                            <IconContext.Provider
                                                                value={{
                                                                    size: "56px",
                                                                }}
                                                            >
                                                                <GiMoneyStack />
                                                            </IconContext.Provider>
                                                            Tunai
                                                        </Stack>
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Button
                                                        fullWidth
                                                        variant={
                                                            toggleModePembayaran ===
                                                            ModePembayaran.TRANSFER
                                                                ? "contained"
                                                                : "outlined"
                                                        }
                                                        onClick={() => {
                                                            pilihQRIS();
                                                        }}
                                                        sx={{
                                                            borderRadius: 4,
                                                            py: 2,
                                                        }}
                                                    >
                                                        <Stack alignItems="center">
                                                            <IconContext.Provider
                                                                value={{
                                                                    size: "56px",
                                                                }}
                                                            >
                                                                <GiWallet />
                                                            </IconContext.Provider>
                                                            Metode Lain
                                                        </Stack>
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box
                                                        visibility={
                                                            toggleModePembayaran ===
                                                            ModePembayaran.TRANSFER
                                                                ? "visible"
                                                                : "hidden"
                                                        }
                                                    >
                                                        <Autocomplete
                                                            loading={
                                                                isLoadingMetodePembayaran
                                                            }
                                                            options={
                                                                metodePembayaran ??
                                                                []
                                                            }
                                                            renderInput={(
                                                                params,
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Pilih metode"
                                                                    variant="outlined"
                                                                />
                                                            )}
                                                            getOptionLabel={(
                                                                option,
                                                            ) =>
                                                                option.namaMetode
                                                            }
                                                            isOptionEqualToValue={(
                                                                option,
                                                                value,
                                                            ) =>
                                                                String(
                                                                    option.id,
                                                                ) ===
                                                                String(value.id)
                                                            }
                                                            fullWidth
                                                            value={
                                                                selectedMetode
                                                            }
                                                            onChange={(
                                                                _event,
                                                                newKategori: MetodeBayarData | null,
                                                            ) => {
                                                                setSelectedMetode(
                                                                    newKategori,
                                                                );
                                                            }}
                                                        />
                                                    </Box>
                                                    {toggleModePembayaran ===
                                                    ModePembayaran.TRANSFER ? (
                                                        <Stack
                                                            direction="row"
                                                            justifyContent="center"
                                                            mt={2}
                                                        >
                                                            <img
                                                                src={SETOSQRIS}
                                                                alt="setos-qris"
                                                                width={600}
                                                                style={{
                                                                    objectFit:
                                                                        "contain",
                                                                }}
                                                            />
                                                        </Stack>
                                                    ) : null}
                                                </Grid>
                                            </Grid>

                                            <Box mt={6}>
                                                <LoadingButton
                                                    fullWidth
                                                    variant="contained"
                                                    loading={
                                                        isProcessingPayment
                                                    }
                                                    size="large"
                                                    color="success"
                                                    disabled={
                                                        !selectedVehicleType ||
                                                        isProcessingPayment
                                                    }
                                                    sx={{
                                                        padding: "10px",
                                                        fontSize: "20px",
                                                    }}
                                                    loadingPosition="center"
                                                    onClick={inputPembayaran}
                                                >
                                                    {isProcessingPayment
                                                        ? "Memproses..."
                                                        : "Bayar"}
                                                </LoadingButton>
                                            </Box>
                                        </Box>
                                    )}
                                </Stack>
                            ) : null}
                        </Collapse>
                    </Box>
                </Grid>
            </Grid>
            <ModalMember
                isOpenModalMember={isOpenModalMember}
                closeModalMember={closeModalMember}
            />
            <ModalImportMember open={isOpenImport} onClose={closeModalImport} />
            <ModalPilihKantong
                open={isOpenModalPilihKantong}
                onClose={closeModalPilihKantong}
            />
        </Box>
    );
};

export default Sewa;
